module.exports = __webpack_public_path__ + "img/abartys.c8e20c91.png";